document.addEventListener("DOMContentLoaded", function () {
    const openButtons = document.querySelectorAll(".image_flat-open-modal");
    const modal = document.querySelector(".header__flat-modal");
    const modalContent = document.querySelector(".header__flat-modal-container");
    const closeButton = document.querySelector(".float-modal_close");

    // Validaciones
    if (openButtons.length === 0) {
        console.warn("⚠️ No se encontró ningún botón con la clase .image_flat-open-modal");
        return;
    }

    if (!modal) {
        console.warn("⚠️ No se encontró el contenedor del modal (.header__flat-modal)");
        return;
    }

    if (!modalContent) {
        console.warn("⚠️ No se encontró el contenedor interno del modal (.header__flat-modal-container)");
        return;
    }

    if (!closeButton) {
        console.warn("⚠️ No se encontró el botón de cierre (.float-modal_close)");
        return;
    }

    // Abrir modal
    openButtons.forEach(button => {
        button.addEventListener("click", () => {
            modal.classList.add("active");
            button.classList.add("active");
        });
    });

    // Cerrar modal desde botón
    closeButton.addEventListener("click", () => {
        modal.classList.remove("active");
        openButtons.forEach(button => button.classList.remove("active"));
    });

    // Cerrar modal al hacer click fuera del contenedor
    document.addEventListener("click", (e) => {
        if (
            modal.classList.contains("active") &&
            !modalContent.contains(e.target) &&
            !e.target.closest(".image_flat-open-modal")
        ) {
            modal.classList.remove("active");
            openButtons.forEach(button => button.classList.remove("active"));
        }
    });
});